'use client';

import { useTranslations } from 'next-intl';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import type { DynamicForm } from '../types';
import { WizardContent } from './wizard-content';

interface DynamicFormWizardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  editingForm?: DynamicForm | null;
  previewOnly?: boolean;
}

export function DynamicFormWizardDialog({
  open,
  onOpenChange,
  editingForm,
  previewOnly = false
}: DynamicFormWizardDialogProps) {
  const t = useTranslations('dynamicForms');
  const isEditing = !!editingForm;

  // Use key to reset internal state when dialog re-opens with different form
  const dialogKey = open
    ? `${editingForm?.id ?? 'new'}-${previewOnly ? 'preview' : 'edit'}`
    : 'closed';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='max-h-[90vh] overflow-y-auto sm:max-w-[700px]'>
        <DialogHeader>
          <DialogTitle>
            {previewOnly
              ? t('preview')
              : isEditing
                ? t('wizardEditTitle')
                : t('wizardTitle')}
          </DialogTitle>
        </DialogHeader>

        {open && (
          <WizardContent
            key={dialogKey}
            editingForm={editingForm}
            previewOnly={previewOnly}
            onClose={() => onOpenChange(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
